import React from "react";
import TeamCard from "./TeamCard";

function WallOfFame(props)
{
 const style={
     backgroundColor:"rgba(0,0,0,0.65)",
     paddingTop:"1rem",
     paddingBottom:"1rem",
     margin:"auto",
     borderRadius:"25px",
     width:"90vw"
 }
    return(
        <div className="team-section" id="wall-of-fame" style={style}>
        <h3 className="team-heading">WALL OF FAME</h3>
        {props.info.filter((val)=>{
                  return (val[2]==="Wall of Fame");
              }).map((item,index)=>{
                  return <TeamCard key={index} name={item[1]} position={item[4]} github={item[5]} linkedIn={item[7]} twitter={item[8]} image={item[3]} domain={item[2]} year={item[10]}/>
              })}
        </div>
    );
}

export default WallOfFame;